import PropTypes from 'prop-types';

const propType = {
  url: PropTypes.string,
  duration: PropTypes.number,
  startDate: PropTypes.number,
};

export default { propType };
